export default __webpack_public_path__ + "static/media/landing.86d68106.svg";